
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.81 14.393a3 3 0 000-4.786 1.788 1.788 0 01-.298-.284c-.264-.321-.404-.732-.276-1.127.17-.525.742-.821 1.223-.55.194.11.38.232.557.366m0 0a5.002 5.002 0 010 7.976 4.991 4.991 0 01-.557.366c-.48.271-1.052-.024-1.223-.55-.128-.395.012-.806.276-1.127a1.743 1.743 0 01.298-.284"}}),_c('path',{attrs:{"d":"M16 19.593V4.408c0-1.719-2.024-2.637-3.317-1.506L8 7H6a3 3 0 00-3 3v4a3 3 0 003 3h2l4.683 4.098C13.976 22.229 16 21.31 16 19.593z"}})])
          )
        }
      }
    